<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>Season of Sacrifice</title>
<link href="../styles/styles.css" rel="stylesheet" type="text/css"/>
<link href="../styles/additional.css" rel="stylesheet" type="text/css"/>
<h3 class="books-by-head">About the Author</h3>
<p class="author-text">Bharti Kirchner is the author of seven critically acclaimed novels, four cookbooks and hundreds of short pieces which were published in magazines and newspapers. Bharti has written for <em>Food &amp; Wine, Writer’s Digest, The Writer, Fitness Plus, San Francisco Chronicle</em> and <em>The Seattle Times</em>. Her essays have appeared in ten anthologies. She has won numerous awards for her writing, including a Virginia Center for the Creative Arts Fellowship. Prior to becoming a writer, Bharti worked as a systems engineer for IBM and as a systems manager for Bank of America, San Francisco. She has also worked in Europe and other continents as a computer systems consultant. Bharti lives in the US with her husband. Visit <a href="http://www.bhartikirchner.com" target="_blank">www.bhartikirchner.com</a> for more details.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// aboutauthor.vue?a1e09116